
import axios from "axios"
import router from '../../router';
import { func } from '../../main';


const state = {
    PersonList: [],
    StateList: [],
    PersonGroupList: [],
    LegalTypeList: [],
    PreInvoiceList: [],
    ContractList: [],
    InvoiceList: [],
    LetterList: [],
    MeetingList: [],
    PreBuyInvoiceList: [],
    BuyList: [],
    CommunicationTypeList: [],
    PersonNoMoreData: false,
    PersonAccess: "0"
};


const getters = {
    GetPersonList(state: any) {
        return state.PersonList;
    },
    GetStateList(state: any) {
        return state.StateList;
    },
    GetPersonGroupList(state: any) {
        return state.PersonGroupList;
    },
    GetLegalTypeList(state: any) {
        return state.LegalTypeList;
    },
    GetCommunicationTypeList(state: any) {
        return state.CommunicationTypeList;
    },
    GetPersonNoMoreData(state: any) {
        return state.PersonNoMoreData;
    },
    GetPersonAccess(state: any) {
        return state.PersonAccess;
    },
    GetPreInvoiceList(state: any) {
        return state.PreInvoiceList;
    },
    GetContractList(state: any) {
        return state.ContractList;
    },
    GetInvoiceList(state: any) {
        return state.InvoiceList;
    },
    GetLetterList(state: any) {
        return state.LetterList;
    },
    GetMeetingList(state: any) {
        return state.MeetingList;
    },
    GetPreBuyInvoiceList(state: any) {
        return state.PreBuyInvoiceList;
    },
    GetBuyList(state: any) {
        return state.BuyList;
    },

};

const mutations = {

    SetInvoiceList(state: any, list: any) {
        state.InvoiceList = list;
    },
    SetPersonList(state: any, list: any) {
        state.PersonList = list;
    },
    SetPreInvoiceList(state: any, list: any) {
        state.PreInvoiceList = list;
    },
    SetContractList(state: any, list: any) {
        state.ContractList = list;
    },
    AddPersonList(state: any, list: any) {
        state.PersonList = state.PersonList.concat(list);
    },
    SetStateList(state: any, list: any) {
        state.StateList = list;
    },
    SetPersonGroupList(state: any, list: any) {
        state.PersonGroupList = list;
    },
    SetLegalTypeList(state: any, list: any) {
        state.LegalTypeList = list;
    },
    SetCommunicationTypeList(state: any, list: any) {
        state.CommunicationTypeList = list;
    },
    SetPersonNoMoreData(state: any, val: any) {
        state.PersonNoMoreData = val;
    },
    SetPersonAccess(state: any, val: any) {
        state.PersonAccess = val;
    },
    SetLetterList(state: any, val: any) {
        state.LetterList = val;
    },
    SetMeetingList(state: any, val: any) {
        state.MeetingList = val;
    },
    SetPreBuyInvoiceList(state: any, val: any) {
        state.PreBuyInvoiceList = val;
    },
    SetBuyList(state: any, val: any) {
        state.BuyList = val;
    },
};

const actions = {
    GetPersonListFromServerForIndex(context: any, filter: any) {
        context.commit("SetLoading", true);
        axios.get("Task/GetAllPersonList", {
            params: {
                pageNumber: filter.pageId,
                text: filter.text,
                rowsperPage: 20
            }
        })
            .then(data => {
                context.commit("SetLoading", false);
                if (data.data.length < 1) {
                    context.commit("SetPersonNoMoreData", true);
                    return;
                }
                if (filter.pageId == 1) {
                    context.commit("SetPersonNoMoreData", false);
                    context.commit("SetPersonList", data.data);
                }
                else {
                    context.commit("SetPersonNoMoreData", false);
                    context.commit("AddPersonList", data.data);
                }
            });
    },
    GetPersonListFromServer(context: any, filter: any) {
        axios.get("Task/GetAllPersonList", {
            params: {
                text: filter.text,
                personId: filter.personId,
            }
        })
            .then(data => {
                context.commit("SetPersonList", data.data);
            });
    },
    GetPreInvoiceAbstractForPerson(context: any, filter: any) {
        axios.get("Task/GetPreInvoiceAbstractForPerson", {
            params: {
                text: filter.text,
                personId: filter.personId,
                preInvoiceId: filter.preInvoiceId
            }
        })
            .then(data => {
                context.commit("SetPreInvoiceList", data.data);
            });
    },
    GetContractAbstractForPerson(context: any, filter: any) {
        axios.get("Task/GetContractAbstractForPerson", {
            params: {
                text: filter.text,
                personId: filter.personId,
                projectId: filter.projectId,
                contractId: filter.contractId,

            }
        })
            .then(data => {
                context.commit("SetContractList", data.data);
            });
    },
    GetInvoiceAbstractForPerson(context: any, filter: any) {
        axios.get("Task/GetInvoiceAbstractForPerson", {
            params: {
                text: filter.text,
                personId: filter.personId,
                contractId: filter.contractId,
                preInvoiceId: filter.preInvoiceId,
                invoiceId: filter.invoiceId,
            }
        })
            .then(data => {
                context.commit("SetInvoiceList", data.data);
            });
    },

    GetLetterAbstractForPerson(context: any, filter: any) {
        axios.get("Task/GetLetterAbstractForPerson", {
            params: {
                text: filter.text,
                personId: filter.personId,
                letterId: filter.letterId,
            }
        })
            .then(data => {
                context.commit("SetLetterList", data.data);
            });
    },
    GetMeetingAbstractForPerson(context: any, filter: any) {
        axios.get("Task/GetMeetingAbstractForPerson", {
            params: {
                text: filter.text,
                personId: filter.personId,
                contractId: filter.contractId,
                projectId: filter.projectId,
                meetingId: filter.meetingId,
            }
        })
            .then(data => {
                context.commit("SetMeetingList", data.data);
            });
    },
    GetBuyAbstractForPerson(context: any, filter: any) {
        axios.get("Task/GetBuyAbstractForPerson", {
            params: {
                text: filter.text,
                personId: filter.personId,
                prebuyInvoiceId: filter.prebuyInvoiceId,
                buyId: filter.buyId,
                contractId: filter.contractId,
            }
        })
            .then(data => {
                context.commit("SetBuyList", data.data);
            });
    },


    CreatePerson(context: any, item: any) {
        context.commit("SetLoading", true);

        axios.post('Person/OutPersonCreateSend', item).then((response: any) => {
            console.log(response);
            if (response.status == 400 || response.data.success == false) {
                const res = response.data.errors.map((a: any) => a.errorMessage);
                func.showErrorMessage(res.join('\n'));
            }
            else {
                func.showSuccessMessage("با موفقیت ثبت شد.");
                setTimeout(function () { router.go(-1); }, 1500);
            }
            context.commit("SetLoading", false);
        }, error => {
            func.showErrorMessage("خطا در ارسال اطلاعات");
            context.commit("SetLoading", false);
            console.log(error);
        });
    },

    GetLegalTypeListFromServer(context: any) {
        axios.get("Person/LegalTypeList")
            .then(data => {
                context.commit("SetLegalTypeList", data.data);
            });
    },
    GetPersonAccess(context: any) {
        axios.get("Person/CanView")
            .then(data => {
                context.commit("SetPersonAccess", data.data);
            });
    },
    GetCommunicationTypeListFromServer(context: any) {
        axios.get("Person/GetCommunicationTypeList")
            .then(data => {
                context.commit("SetCommunicationTypeList", data.data);
            });
    },
    GetPersonGroupListFromServer(context: any, filter: any) {
        axios.get("Person/GetPersonGroupList", {
            params: {
                text: filter.text,
            }
        })
            .then(data => {
                context.commit("SetPersonGroupList", data.data);
            });
    },
    GetStateListFromServer(context: any, filter: any) {
        axios.get("Person/GetStateList", {
            params: {
                text: filter.text,
            }
        })
            .then(data => {
                context.commit("SetStateList", data.data);
            });
    },
};

export default {
    state,
    getters,
    mutations,
    actions
};
